export const createTypography = () => {
  return {
    // Using "Poppins" as a modern alternative.
    fontFamily: '"Poppins", -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji"',
    body1: {
      fontSize: '0.9rem', // reduced from 1rem
      fontWeight: 400,
      lineHeight: 1.5,
      wordWrap: 'break-word'
    },
    body2: {
      fontSize: '0.8rem', // reduced from 0.875rem
      fontWeight: 400,
      lineHeight: 1.57,
      wordWrap: 'break-word'
    },
    body3: {
      fontSize: '0.7rem', // reduced from 0.8rem
      fontWeight: 400,
      lineHeight: 1.57,
      wordWrap: 'break-word'
    },
    button: {
      fontWeight: 600
    },
    caption: {
      fontSize: '0.7rem', // reduced from 0.75rem
      fontWeight: 500,
      lineHeight: 1.66
    },
    subtitle1: {
      fontSize: '0.9rem', // reduced from 1rem
      fontWeight: 500,
      lineHeight: 1.57,
      wordWrap: 'break-word'
    },
    subtitle2: {
      fontSize: '0.8rem', // reduced from 0.875rem
      fontWeight: 500,
      lineHeight: 1.57,
      wordWrap: 'break-word'
    },
    overline: {
      fontSize: '0.7rem', // reduced from 0.75rem
      fontWeight: 600,
      letterSpacing: '0.5px',
      lineHeight: 2.5,
      textTransform: 'uppercase'
    },
    h1: {
      // Using "Poppins" for a modern, geometric look.
      fontFamily: '"Poppins", sans-serif',
      fontWeight: 700,
      fontSize: '3rem', // reduced from 3.5rem
      lineHeight: 1.2
    },
    h2: {
      fontFamily: '"Poppins", sans-serif',
      fontWeight: 700,
      fontSize: '2.5rem', // reduced from 3rem
      lineHeight: 1.2
    },
    h3: {
      fontFamily: '"Poppins", sans-serif',
      fontWeight: 700,
      fontSize: '2rem', // reduced from 2.25rem
      lineHeight: 1.2
    },
    h4: {
      fontFamily: '"Poppins", sans-serif',
      fontWeight: 700,
      fontSize: '1.75rem', // reduced from 2rem
      lineHeight: 1.2
    },
    h5: {
      fontFamily: '"Poppins", sans-serif',
      fontWeight: 700,
      fontSize: '1.3rem', // reduced from 1.5rem
      lineHeight: 1.2
    },
    h6: {
      fontFamily: '"Poppins", sans-serif',
      fontWeight: 700,
      fontSize: '1rem', // reduced from 1.125rem
      lineHeight: 1.2
    }
  };
};

